module.exports = "/_next/static/images/PrintablePreview2-7a3c595483c3a88d6228f39c54663ba6.png";